import { getSchedulerDataServicesMaintenance } from "../services";
import { filteredServicesComponents } from "../filteredServicesComponent"

export function PlumbingMaintenance (){
  
  let servicesStart = [
  {
    id: "Septic Pumping",
    label: <>Septic Pumping</>,
    jobType: "Septic Tank",
    remType: "maintenance",
    data: [],
  },

  {
    id: "Water Heater Flush",
    label: <>Water Heater Flush</>,
    data: [
      [
        {
          name: "equipmentType",
          question: "What kind of water heater Flush do you have?",
          answers: [
            {
              id: "Regular Tank",
              label: <>Regular Tank</>,
              value: "Regular Tank",
              jobType: "Water Heater: Non-Member",
              remType: "maintenance",
            },
            {
              id: "Tankless",
              label: <>Tankless</>,
              value: "Tankless Water Heater",
              jobType: "Tankless Water Heater: Non-Member",
              remType: "maintenance",
            },
          ],
        },
        {
          name: "memberType",
          question: "Are you a maintenance program member?",
          answers: [
            {
              id: "Yes",
              label: <>Yes</>,
              value: "Yes",
              subJobType: "Member",
            },
            {
              id: "No",
              label: <>No</>,
              value: "No",
              subJobType: "Non-Member",
            },
          ],
        },
        
      ],
    ],
  },
  {
    id: "Member Maintenance",
    label: <>Member Maintenance</>,
    jobType: "Water Heater: Member",
    remType: "maintenance",
    data: [],
  },
  {
    id: "Sump Pumps",
    label: <>Sump Pumps</>,
    jobType: "Sump Pump",
    remType: "maintenance",
    data: [],
  },
  {
    id: "Well Pump",
    label: <>Well Pump</>,
    jobType: "Well Pump",
    remType: "maintenance",
    data: [],
  },
];

const jobTypeFilter = getSchedulerDataServicesMaintenance// Replace with the desired job type to filter
  
return filteredServicesComponents(servicesStart, jobTypeFilter);
}